import {
  autocompleteClasses,
  buttonBaseClasses,
  Components,
  iconClasses,
  inputBaseClasses,
  outlinedInputClasses,
  textFieldClasses,
  Theme,
} from '@mui/material';

export function getAutocomplete(theme: Theme): Components['MuiAutocomplete'] {
  return {
    styleOverrides: {
      root: {
        [`& .${inputBaseClasses.root}`]: {
          [`&:hover, &.${autocompleteClasses.focused}`]: {
            borderColor: theme.palette.background.default,
          },
        },

        [`&.${autocompleteClasses.hasPopupIcon} .${outlinedInputClasses.root}`]:
          {
            paddingRight: 0,
            paddingLeft: theme.spacing(4),
            backgroundColor: theme.palette.background.default,

            [`&.${inputBaseClasses.colorSecondary}`]: {
              backgroundColor: theme.palette.background.paper,
            },

            [`&.${autocompleteClasses.focused} .${buttonBaseClasses.root} svg`]:
              {
                color: theme.palette.grey[900],
              },
          },

        [`&.${autocompleteClasses.hasPopupIcon}.${autocompleteClasses.hasClearIcon} .${outlinedInputClasses.root}`]:
          {
            paddingRight: 0,
          },

        [`& .${outlinedInputClasses.root}`]: {
          padding: 0,
          backgroundColor: 'transparent',

          [`& .${autocompleteClasses.input}`]: {
            padding: theme.spacing(3, 3, 3, 0),
            '&::-webkit-input-placeholder': {
              color: theme.palette.grey[600],
              fontWeight: 600,
            },
          },
        },

        [`.${textFieldClasses.root}`]: {
          [`.${inputBaseClasses.root}`]: {
            [`&.${inputBaseClasses.multiline}`]: {
              alignContent: 'flex-start',

              gap: theme.spacing(1),

              padding: theme.spacing(3, 4),
            },
          },
        },

        [`.${autocompleteClasses.tag}`]: {
          margin: 0,
        },
      },

      popper: {
        boxShadow: `0px 2px 5px rgba(31, 34, 38, 0.1), 0px 3px 15px rgba(31, 34, 38, 0.1)`,
        borderRadius: theme.shape.borderRadius,
      },

      listbox: {
        padding: 0,

        [`& .${iconClasses.root}`]: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },

      option: {
        margin: theme.spacing(0.5),
        padding: theme.spacing(1),
        borderRadius: theme.shape.borderRadiusMd, // ex 14,
        [`&[aria-selected="true"], &.${autocompleteClasses.focused}, &[aria-selected="true"].${autocompleteClasses.focused}`]:
          {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.background.default,
          },
      },
    },
  };
}
